module.exports = __webpack_public_path__ + "static/lframe-motor-bike-loan-c7c0c5d46de9e056bbe23167f8c6afa9.png";